export default function resolveGroupRowId(profile: CashFlowStatementProfile, rowId: string): string {
    if (profile.groupRowIdBySubGroupRowId[rowId]) {
        return profile.groupRowIdBySubGroupRowId[rowId];
    }
    if (profile.groupRowIdByCategoryRowId[rowId]) {
        return profile.groupRowIdByCategoryRowId[rowId];
    }
    return rowId;
}
